export default __webpack_public_path__ + "static/media/sleepy.448257f7.mp3";